import React, { useState, useEffect } from 'react';
import '../../Styles/Topbar.css';
import Sidebar from './Sidebar';

const Topbar = ({onLogout}) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <>
      <Sidebar onLogout={onLogout}/> {/* Sidebar is always visible */}

      <div className="topbar">
        <div className='extra'>.</div>
        <div className="topbar-logo-container">
          <h1 className="topbar-logo-text">
            <span className="topbar-stylish-2">LZAY</span> Quote
          </h1>
        </div>
        {user && (
          <div className="topbar-username">
            <h1 className="topbar-username">{user.first_name}</h1>
          </div>
        )}
      </div>
    </>
  );
};

export default Topbar;
